import { EnglishIcon } from 'components/ui-kit/icons/iconComponents/EnglishIcon'
import { FrenchIcon } from 'components/ui-kit/icons/iconComponents/FrenchIcon'
import { GermanIcon } from 'components/ui-kit/icons/iconComponents/GermanIcon'
import { PortugalIcon } from 'components/ui-kit/icons/iconComponents/PortugalIcon'
import { RussianIcon } from 'components/ui-kit/icons/iconComponents/RussianIcon'
import { SpanishIcon } from 'components/ui-kit/icons/iconComponents/SpanishIcon'

/* ==========================================================================
  LANGUAGES
  ========================================================================== */
const LANGUAGES = [
  { label: 'English', languageCode: 'en', flag: EnglishIcon },
  { label: 'German', languageCode: 'de', flag: GermanIcon },
  { label: 'Spanish', languageCode: 'es', flag: SpanishIcon },
  { label: 'French', languageCode: 'fr', flag: FrenchIcon },
  { label: 'Portuguese', languageCode: 'pt', flag: PortugalIcon },
  { label: 'Russian', languageCode: 'ru', flag: RussianIcon }
]

/* ==========================================================================
  HTTP Method Types
========================================================================== */
const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
  Transaction types
========================================================================== */
export const TRANSACTION_TYPES = {
  BET: 'bet',
  WIN: 'win',
  ROLLBACK: 'rollback'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
const TOKEN = 'admin_authtoken'
const LANGUAGE = 'admin_language'
const ADMIN_ID = 'admin_id'
const ROLE = 'operator_role'

/* ==========================================================================
Operator Roles
========================================================================== */
const OPERATOR_ROLES = {
  operator: 'OPERATOR',
  operatorUser: 'OPERATOR_USER'
}

/* ==========================================================================
Loader types
========================================================================== */
const LOADER_TYPE = {
  SCALE: 'scale',
  PULSE: 'pulse'
}

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
const TOASTER_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}

/* ==========================================================================
  Loader Types
========================================================================== */
const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Table Cell Type
========================================================================== */
const TABLE_CELL_TYPE = {
  status: 'status',
  switch: 'switch',
  button: 'button',
  date: 'date',
  text: 'text',
  number: 'number',
  nestedValue: 'nestedValue',
  default: 'default',
  updateIconButton: 'updateIconButton',
  statusIconButton: 'statusIconButton',
  deleteIconButton: 'deleteIconButton',
  actionCell: 'actionCell',
  enableDisable: 'enableDisable',
  tableActionCell: 'tableActionCell',
  viewDetail: 'viewDetail'
}

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
// const gamesSectionParentRoute = '/games'
// const playersSectionParentRoute = '/players'
// const performanceSectionParentRoute = '/performance'

const ROUTE_PATHS = {
  rootPath: '/',
  login: '/login',
  changePassword: '/change-password',
  resetPassword: '/reset-password/:adminId/:token',
  settings: '/settings',
  dashboard: '/dashboard',
  gameSettings: '/game-settings',
  editGameSettings: '/game-settings/edit',
  gameList: '/games-settings/list',
  gameTables: '/tables',
  cashGames: '/cash-games',
  cashGamesTable: '/cash-games',
  tournaments: '/tournaments',
  tournamentTablesDetails: '/tournaments/:tournamentId/tables',
  createGameTable: '/table/create',
  viewGameTable: '/table/details',
  editGameTable: '/table/edit',
  currencies: '/currencies',
  users: '/users',
  usersDetail: '/users/:userId/details',
  editUser: '/users/:userId/edit',
  onlineUser: '/online-user',
  transactions: '/transactions',
  reports: '/reports',
  transactionReports: '/reports/transactions',
  notFound: '/not-found'
}

/* ==========================================================================
  DIALOG Types
========================================================================== */
const DIALOG_TYPE = {
  add: 'add',
  update: 'update',
  delete: 'delete',
  view: 'view',
  hide: ''
}

/* ==========================================================================
  Miscellaneous Constants
========================================================================== */
export const DEFAULT_PAGE_NO = 1
export const DEFAULT_CURRENCY_ID = 1
export const DEFAULT_CURRENCY_NAME = 'United States Dollar'
export const DEFAULT_DASHBOARD_CURRENCY_CODE = 'USD'
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'
export const SELECTED_FIAT = 'USD'

const DEFAULT_GAME_ID = {
  CRASH: 1,
  PLINKO: 2,

  /* =======EXA GAME ID's ======== */

  /* =======CRASH GAME ID's======== */
  AVIATOR_CRASH: 18,
  AZTEC_MAN_CRASH: 19,
  GALAXY_GRAB_CRASH: 20,
  FOLLOW_THE_ARROW_CRASH: 21,
  POWER_OF_THOR_CRASH: 22,

  /* =======OTHER CRASH GAME ID's======== */
  E_PLINKO: 23,
  E_BLACKJACK: 24,
  E_MINE: 25,
  E_ROULETTE: 26
  /* =================================== */

}

// Export All constant variables
export {
  TOASTER_TYPE,
  LANGUAGES,
  TOKEN,
  LANGUAGE,
  ADMIN_ID,
  ROLE,
  OPERATOR_ROLES,
  ROUTE_PATHS,
  LOADER_TYPE,
  METHOD_TYPES,
  LOADER_HANDLER_TYPES,
  TABLE_CELL_TYPE,
  DIALOG_TYPE,
  DEFAULT_GAME_ID
}

export const maxOddGameId = ['1', '2', '3', '4', '8', '10', '12', '13', '14', '16', '17', '18']
export const minOddGameId = ['1', '2', '3', '4', '8', '10', '12', '13', '14', '16', '17', '18']
export const houseEdgeGameId = ['1', '2', '3', '4', '5', '6', '7', '8', '10', '12', '13', '14', '16', '17', '18']
export const minAutoRateGameId = ['1', '2', '3', '4', '12', '18']
